import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { PermissionsProtectedRoute } from 'client/routes/PermissionsProtectedRoute';
import { TeamRoutes } from './RouteHelpers';
import { TeamPage } from './components/TeamPage';
import { TeamsPage } from './containers/TeamsPage';
import { teamPermissions } from './permissions/Team';
import ReconciliationMismatchesPage from './components/ReconciliationMismatches';
import SalesforceAccountPage from './components/SalesforceAccount';

const TeamsListPage = React.lazy(() => import('./containers/TeamsListPage'));

export const teamRoutes: RouteObject = {
  path: 'teams',
  element: (
    <PermissionsProtectedRoute
      pageId={teamPermissions.pageId}
      currentPath={TeamRoutes.Team}
    />
  ),
  children: [
    {
      path: TeamRoutes.PageIndex,
      element: <Navigate to="/search" replace />,
    },
    // The static `list` segment outranks `teams/:id` in React Router, the same
    // way `/teams/reconciliation-mismatches` does.
    {
      path: TeamRoutes.TeamsList,
      element: (
        <React.Suspense fallback={undefined}>
          <TeamsListPage />
        </React.Suspense>
      ),
    },
    {
      path: TeamRoutes.Team,
      element: <TeamPage />,
    },
    {
      path: TeamRoutes.Salesforce,
      element: <SalesforceAccountPage />,
    },
    {
      path: TeamRoutes.ReconciliationMismatches,
      element: <ReconciliationMismatchesPage />,
    },
  ],
};

export const search: RouteObject = {
  path: 'search',
  element: (
    <PermissionsProtectedRoute
      pageId={teamPermissions.pageId}
      currentPath={TeamRoutes.Search}
    />
  ),
  children: [
    {
      path: TeamRoutes.Search,
      element: <TeamsPage />,
    },
  ],
};
